import {
  required, maxLength,
} from 'vuelidate/lib/validators';

export default {
  headers: [
    { text: 'Názov', value: 'name' },
    { text: 'Trieda', value: 'internal_class' },
    { text: 'Vytvorený', value: 'created_at' },
    { text: 'Upravený', value: 'updated_at' },
    { text: 'Akcie', value: 'action', sortable: false },
  ],
  formModel: [{
    name: 'name',
    type: 'text',
    label: 'Názov',
    class: 'sm6',
    icon: 'person',
    validations: {
      required, maxLength: maxLength(255),
    },
    // defaultValue: 'test'
  },
  {
    name: 'internal_class',
    type: 'text',
    label: 'Trieda',
    // class: 'sm12',
    class: 'sm6',
    icon: 'email',
    validations: {
      required, maxLength: maxLength(255),
    },
    // defaultValue: 'test'
  },

  ],
};
